var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "default-page-paddings" }, [
    _c(
      "div",
      { staticClass: "container container-small" },
      [
        _c("Heading", {
          attrs: {
            alignment: "text-left",
            title: _vm.$t("contact_title"),
            routeName: "vignette",
          },
        }),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-sm-5" }, [
            _c("div", { staticClass: "mt-4" }, [
              _vm._m(0),
              _vm._m(1),
              _c("p", { staticClass: "sub-header" }, [
                _c("b", [_vm._v(_vm._s(_vm.$t("contact_viggnete_emission")))]),
              ]),
              _vm._m(2),
              _vm._m(3),
            ]),
          ]),
          _c("div", { staticClass: "col-sm-7" }, [
            _c("div", { staticClass: "contact-form" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("label", [_vm._v(_vm._s(_vm.$t("label_first_name")) + "*")]),
                _vm.errors.name.status
                  ? _c("span", { staticClass: "invalid-feedback" }, [
                      _vm._v(" " + _vm._s(_vm.errors.name.error) + " "),
                    ])
                  : _vm._e(),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.name,
                      expression: "name",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text" },
                  domProps: { value: _vm.name },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.name = $event.target.value
                    },
                  },
                }),
              ]),
              _c("div", { staticClass: "form-group" }, [
                _c("label", [_vm._v(_vm._s(_vm.$t("label_email")) + "*")]),
                _vm.errors.email.status
                  ? _c("span", { staticClass: "invalid-feedback" }, [
                      _vm._v(" " + _vm._s(_vm.errors.email.error) + " "),
                    ])
                  : _vm._e(),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.email,
                      expression: "email",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text" },
                  domProps: { value: _vm.email },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.email = $event.target.value
                    },
                  },
                }),
              ]),
              _c("div", { staticClass: "form-group" }, [
                _c("label", [_vm._v(_vm._s(_vm.$t("label_category")) + "*")]),
                _vm.errors.category.status
                  ? _c("span", { staticClass: "invalid-feedback" }, [
                      _vm._v(" " + _vm._s(_vm.errors.category.error) + " "),
                    ])
                  : _vm._e(),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.category,
                        expression: "category",
                      },
                    ],
                    staticClass: "form-control",
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.category = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                    },
                  },
                  [
                    _c("option", { domProps: { value: null } }, [
                      _vm._v(_vm._s(_vm.$t("label_choose_category_contact"))),
                    ]),
                    _vm._l(5, function (i) {
                      return _c("option", { domProps: { value: i } }, [
                        _vm._v(_vm._s(_vm.$t("category_" + i))),
                      ])
                    }),
                  ],
                  2
                ),
              ]),
              _c("div", { staticClass: "form-group" }, [
                _c("label", [_vm._v(_vm._s(_vm.$t("label_message")) + "*")]),
                _vm.errors.message.status
                  ? _c("span", { staticClass: "invalid-feedback" }, [
                      _vm._v(" " + _vm._s(_vm.errors.message.error) + " "),
                    ])
                  : _vm._e(),
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.message,
                      expression: "message",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { id: "message" },
                  domProps: { value: _vm.message },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.message = $event.target.value
                    },
                  },
                }),
              ]),
              _vm.contactSentStatus == "success"
                ? _c("div", { staticClass: "alert alert-success" }, [
                    _vm._v(
                      " " + _vm._s(_vm.$t("message_sent_successfully")) + " "
                    ),
                  ])
                : _vm._e(),
              _vm.contactSentStatus == "error"
                ? _c("div", { staticClass: "alert alert-danger" }, [
                    _vm._v(" " + _vm._s(_vm.$t("message_sent_error")) + " "),
                  ])
                : _vm._e(),
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  !_vm.hideSendBtn
                    ? _c(
                        "van-button",
                        {
                          staticClass: "main-btn text-center",
                          attrs: {
                            dusk: "login-button",
                            block: "",
                            loading: _vm.loading,
                            square: "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.sendContactForm()
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("btn_send")))]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]),
          ]),
        ]),
        _c("p", { staticClass: "sub-header mt-4" }, [
          _c("b", [_vm._v(_vm._s(_vm.$t("contact_agencies")))]),
        ]),
        _c("p", [
          _c(
            "a",
            {
              staticClass: "custom-link",
              attrs: {
                href: "http://www.untrr.ro/birouri-regionale.html",
                target: "_blank",
              },
            },
            [_vm._v(_vm._s(_vm.$t("contact_see_all_agencies")))]
          ),
          _vm._v(
            " " + _vm._s(_vm.$t("contact_see_all_agencies_continuation")) + " "
          ),
        ]),
        _c(
          "GmapMap",
          {
            staticStyle: { width: "100%", height: "300px" },
            attrs: { center: { lat: 44.421762, lng: 26.1013369 }, zoom: 18 },
          },
          [
            _c("GmapMarker", {
              attrs: { position: { lat: 44.421762, lng: 26.1013369 } },
            }),
            _c("GmapMarker", {
              attrs: { position: { lat: 46.1988442, lng: 21.3311147 } },
            }),
            _c("GmapMarker", {
              attrs: { position: { lat: 46.091314, lng: 21.688964 } },
            }),
            _c("GmapMarker", {
              attrs: { position: { lat: 44.8604776, lng: 24.8813793 } },
            }),
            _c("GmapMarker", {
              attrs: { position: { lat: 47.1031227, lng: 21.8308696 } },
            }),
            _c("GmapMarker", {
              attrs: { position: { lat: 46.7772626, lng: 23.6140619 } },
            }),
            _c("GmapMarker", {
              attrs: { position: { lat: 45.7968882, lng: 24.1459271 } },
            }),
            _c("GmapMarker", {
              attrs: { position: { lat: 47.795759, lng: 22.870274 } },
            }),
            _c("GmapMarker", {
              attrs: { position: { lat: 47.641079, lng: 26.252882 } },
            }),
            _c("GmapMarker", {
              attrs: { position: { lat: 45.8697246, lng: 22.9151715 } },
            }),
            _c("GmapMarker", {
              attrs: { position: { lat: 47.1749498, lng: 27.5305876 } },
            }),
            _c("GmapMarker", {
              attrs: { position: { lat: 45.760854, lng: 21.2380413 } },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "sub-header" }, [
      _c("b", [_vm._v("U.N.T.R.R. Bucuresti")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v(" Str. Ienăchiţă Văcărescu Nr. 60"),
      _c("br"),
      _vm._v(" Bucureşti, Sector 4, 040157"),
      _c("br"),
      _vm._v(" Email: "),
      _c(
        "a",
        {
          staticClass: "custom-link",
          attrs: { href: "mailto:office@e-rovinieta.ro" },
        },
        [_vm._v("office@e-rovinieta.ro")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v(" Dna. Cerasela Lorent"),
      _c("br"),
      _vm._v(" Telefon: "),
      _c(
        "a",
        { staticClass: "custom-link", attrs: { href: "tel:+40720999247" } },
        [_vm._v("+40720999247")]
      ),
      _c("br"),
      _vm._v(" Email: "),
      _c(
        "a",
        {
          staticClass: "custom-link",
          attrs: { href: "mailto:cerasela.lorent@untrr.ro" },
        },
        [_vm._v("cerasela.lorent@untrr.ro")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v(" Dna. Alamorean Marinela"),
      _c("br"),
      _vm._v(" Telefon: "),
      _c(
        "a",
        { staticClass: "custom-link", attrs: { href: "tel:+40720999246" } },
        [_vm._v("+40720999246")]
      ),
      _c("br"),
      _vm._v(" Email: "),
      _c(
        "a",
        {
          staticClass: "custom-link",
          attrs: { href: "mailto:marinela.alamorean@untrr.ro" },
        },
        [_vm._v("marinela.alamorean@untrr.ro")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }